import { getShareLink } from '@/shared/helpers/telegram/share/share-game';

import { Method } from '../types';
import { type Responder } from './respond-with-message';
import { validateMessageData } from './validate-message-data';
import { warnIncorrectValues } from './warn-incorrect-values';

export const getShareLinkHandler = (value: any, gameKey: string, respond: Responder) => {
  const { parameters } = value;
  if (parameters) {
    if (!validateMessageData({ value: parameters, allowedTypes: ['object'] })) {
      warnIncorrectValues(Method.GET_SHARE_LINK, 'parameters', ['object']);
    }
  }

  const shareLink = getShareLink(gameKey, parameters ?? value);
  respond({ method: Method.GET_SHARE_LINK, value: shareLink });
};
